import { withStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PF2MTabs from '~/components/PF2MTabs';
import EquipmentChatTab from './EquipmentChatTab';
import GroupsConfigTab from './GroupsConfigTab';
import MessagesRegistationTab from './MessageRegistrationTab';
import styles from './styles';
import { useDispatch } from 'react-redux';
import { getEquipmentGroups, getEquipmentTypes } from '~/store/nref/actions';

const DispatchControl = () => {
  const dispatch = useDispatch();
  const [loadedData, setLoadedData] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);

  const { t: translate } = useTranslation();

  const tabs = [
    { key: 0, label: translate('common:Chat') },
    { key: 1, label: translate('common:GroupsConfiguration') },
    { key: 2, label: translate('common:MessageRegistration') },
  ];

  const handleChange = (event, value) => {
    setSelectedTab(value);
  };

  useEffect(() => {
    if (!loadedData) {
      dispatch(getEquipmentTypes());
      dispatch(getEquipmentGroups());
      setLoadedData(true);
    }
  }, [loadedData, dispatch]);

  return (
    <>
      <PF2MTabs
        value={selectedTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        hideSyncButton
        style={{ marginTop: '5px' }}
      >
        {tabs}
      </PF2MTabs>

      {selectedTab === 0 ? <EquipmentChatTab /> : null}
      {selectedTab === 1 ? <GroupsConfigTab /> : null}
      {selectedTab === 2 ? <MessagesRegistationTab /> : null}
    </>
  );
};

export default withStyles(styles)(DispatchControl);
